import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_aikxxfpecb: FaireBrandEntity = {
  token: "b_aikxxfpecb",
  type: "brand",
  name: "Threaded Pear",
  avatarUrl:
    "https://cdn.faire.com/fastly/c71b47884231928a0cde26d7a2c8023e23102aaff7b2632b2b1c26c3ac46dbeb.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/1ae2445805cba44f991ac109c57ec3b5584bd28f01b10567cb079f58c8c73072.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c71b47884231928a0cde26d7a2c8023e23102aaff7b2632b2b1c26c3ac46dbeb.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1ae2445805cba44f991ac109c57ec3b5584bd28f01b10567cb079f58c8c73072.jpeg",
  location: "Southlake, TX, USA",
  minimumOrderDollars: 99,
  rating: 4.8,
  reviewCount: 602,
  isInsider: true,
  description:
    "Threaded Pear started as a way to replace my teacher's salary. Although I loved what I did I loved the idea of being able to be more accessible to my family. We gained such a strong following within that first year that my husband was able to leave his career and we haven't looked back! The fact that my husband has such a strong background in business allowed us to grow so rapidly. It was a leap of faith and we would do it again and again. The key to success for us has been the fact that we are passionate about this being our \"Family Business\" and getting to go to work with your best friend everyday. The love of what we do allows us to purposefully select and create items that we know you will love just as much as we do.\n\nThank you for letting us be a part of your business!\n\n-Marcus & Mandy",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:16.674Z",
    importedBy: "entity-db-cli",
  },
};
